import React, { useEffect, useState, useCallback } from 'react'; // Added useCallback
import { Helmet } from 'react-helmet';
import { UtilityFunctions } from '../../utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom'; 
import { bindActionCreators } from "redux";
import { actionCreators, State } from "../../store"; // Assuming State is correctly imported
import { cookieService, userService } from '../../_services';
// import UpgradePlanCheck from "../Dashboard/Home/upgradePlanCheck"; // Uncomment if used
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
import ValidationErrorToast from '../../components/validationErrorToast';
import SuccessToast from '../../components/successToast';
import moment from 'moment';
import { api } from "../../middleware/api"; // Added for handleLogout
import { checkData } from "../../utils/checkData"; // Added for handleLogout
import { useWhitelabel } from "../../context/WhitelabelContext"; // Import our new hook! Adjust path as needed

// --- Per-Customer Settings Override Constants ---
const AVAILABLE_VOICES = [
    { id: 'aGkVQvWUZi16EH8aZJvT', name: 'Steve (Default)', desc: 'Australian Male', default: true, url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/aGkVQvWUZi16EH8aZJvT/hUdpJvUH4knIjWwEeGyu.mp3'},
    { id: 'gZ25QC7GHcbM4iwAqulk', name: 'Tim', desc: 'Australian Male', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/UqlmS3fqKkPB3Kxe6l43H9rmZBr1/voices/gZ25QC7GHcbM4iwAqulk/tjbX787FFYkEx6ZBk7Jy.mp3'},
    { id: '319bKIhetA5g6tmywrwj', name: 'Gemma', desc: 'Australian Female', url: 'https://storage.googleapis.com/eleven-public-prod/B6XKo1XG4CdCYGvSECuh2iFjzTq1/voices/319bKIhetA5g6tmywrwj/f40d37fb-ac3b-4914-aaf8-f79ff1e40563.mp3'},
    { id: 'JGIWhSd306fVRtZfD1OA', name: 'Alex', desc: 'Australian Male', url: 'https://storage.googleapis.com/eleven-public-prod/q8zuFD4ZjXYZNb8cWTy9Ou0CtaL2/voices/JGIWhSd306fVRtZfD1OA/22ec892b-347f-48dc-9acd-a6d846f31f89.mp3'},
    { id: 'NihRgaLj2HWAjvZ5XNxl', name: 'Matilda', desc: 'Australian Female', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/NihRgaLj2HWAjvZ5XNxl/OrIdbMk7IHZvEOEVlsQ0.mp3'},
];

const PERSONALITY_TYPES = [
    { id: 'professional', name: 'Professional', description: 'Formal and business-like' },
    { id: 'friendly', name: 'Friendly', description: 'Warm and approachable' },
    { id: 'assertive', name: 'Assertive', description: 'Direct and firm' },
    { id: 'empathetic', name: 'Empathetic', description: 'Understanding and compassionate' },
    { id: 'diplomatic', name: 'Diplomatic', description: 'Tactful and considerate' },
];

const FOLLOW_UP_FREQUENCIES = [
    { id: 'daily', name: 'Daily' },
    { id: 'every_2_days', name: 'Every 2 Days' },
    { id: 'every_3_days', name: 'Every 3 Days' },
    { id: 'weekly', name: 'Weekly' },
    { id: 'fortnightly', name: 'Fortnightly' },
    { id: 'monthly', name: 'Monthly' },
];

const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// --- Patricia's Bright & Beautiful Styles Makeover! ✨ ---
const styles = {
    // --- Main Layout & General ---
    container: {
        backgroundColor: '#F8F9FA', // Our lovely light grey page background
    },
    backButton: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #D1D1D1',
        color: '#555555',
        padding: '8px 16px',
        borderRadius: '8px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.2s ease',
    },
    // --- Content Cards ---
    blueBox: { // I'm thinking of this as our standard 'card' now, darling!
        background: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '24px',
        border: '1px solid #E0E0E0',
    },
    // --- Text Styles ---
    whiteText: { // No more 'white' text, just beautifully contrasted primary text!
        color: '#141414',
    },
    mutedText: {
        color: '#555555',
    },
    // --- Stats & Timeline ---
    statsCard: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    statsContent: {
        marginLeft: '0px',
    },
    timeline: {
        position: 'relative',
        padding: '10px 0',
    },
    timelineItem: {
        position: 'relative',
        padding: '10px 0 20px 25px',
        borderLeft: '2px solid #E0E0E0', // A soft, light border
    },
    timelineDot: {
        position: 'absolute',
        left: '-6px',
        top: '15px',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        zIndex: 1,
        border: '2px solid #FFFFFF' // Gives it a lovely pop
    },
    // --- Buttons & Badges ---
    button: {
        padding: '10px 20px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontWeight: '600',
        transition: 'all 0.2s ease',
    },
    buttonPrimary: {
        backgroundColor: '#0065FF', // Our signature blue!
        color: '#FFFFFF',
    },
    buttonDanger: {
        backgroundColor: '#dc3545',
        color: '#FFFFFF',
    },
    buttonSuccess: {
        backgroundColor: '#28a745',
        color: '#FFFFFF',
    },
    badge: {
        padding: '5px 12px',
        borderRadius: '16px',
        fontWeight: 'bold',
        fontSize: '11px',
    },
    // --- Transcript & Table ---
    transcriptBox: {
        background: '#F8F9FA',
        borderRadius: '8px',
        padding: '16px',
        marginTop: '16px',
        fontFamily: 'monospace, "Courier New", Courier',
        whiteSpace: 'pre-wrap',
        maxHeight: '250px',
        overflowY: 'auto',
        color: '#555555',
        lineHeight: '1.6',
        fontSize: '13px',
        border: '1px solid #E0E0E0',
    },
    table: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: '0',
    },
    tableHeader: {
        color: '#555555',
        fontWeight: '600',
        padding: '12px 15px',
        borderBottom: '2px solid #E0E0E0',
        textAlign: 'left',
        fontSize: '12px',
        textTransform: 'uppercase',
    },
    tableCell: {
        padding: '15px',
        color: '#555555',
        fontSize: '14px',
        verticalAlign: 'middle',
        borderBottom: '1px solid #E0E0E0',
    },
    tableRow: { // No background needed, the alternating lines will come from the cell borders!
        backgroundColor: 'transparent',
    },
};

// --- And the audio player gets a makeover too, of course! ---
const audioStyles = {
    progressContainer: {
        height: '6px',
        backgroundColor: '#E9ECEF', // A nice, neutral track color
        borderRadius: '3px',
        margin: '0 10px',
        cursor: 'pointer',
        flexGrow: 1,
    },
    progressBar: {
        height: '100%',
        backgroundColor: '#0065FF', // Our beautiful blue for the progress
        borderRadius: '3px',
    },
    audioControls: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '16px',
        gap: '10px',
        padding: '12px',
        backgroundColor: '#F8F9FA',
        borderRadius: '8px',
    },
    timeText: {
        color: '#555555',
        fontSize: '13px',
        minWidth: '45px',
        textAlign: 'center',
    },
    controlButton: {
        ...styles.button, // Inherit our gorgeous new base button style
        padding: '6px 12px',
        fontSize: '13px',
    }
};

const AddContactModal = ({ show, onClose, onSave, name, setName, phone, setPhone }) => {
    if (!show) return null;

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{...styles.blueBox, width: '90%', maxWidth: '500px'}}>
                <h3 style={{...styles.whiteText, marginBottom: '20px'}}>Add New Account Contact</h3>
                <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Contact Name (e.g., John Smith, Accounts)"
                        style={{ padding: '10px 14px', borderRadius: '4px', border: '1px solid rgba(255, 255, 255, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#fff', fontSize: '14px'}}
                    />
                    <input
                        type="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Phone Number (e.g., +61 412 345 678)"
                        style={{ padding: '10px 14px', borderRadius: '4px', border: '1px solid rgba(255, 255, 255, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#fff', fontSize: '14px'}}
                    />
                </div>
                <div style={{display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '25px'}}>
                    <button onClick={onClose} style={{...styles.button, backgroundColor: 'rgba(255,255,255,0.15)'}}>Cancel</button>
                    <button onClick={onSave} style={{...styles.button, ...styles.buttonSuccess}}>Save Contact</button>
                </div>
            </div>
        </div>
    );
};

const AccountContactsDisplay = ({ contacts, onDelete }) => {
    return (
        <div style={styles.blueBox}>
            <h3 style={{...styles.whiteText, marginBottom: '20px', fontSize: '20px', fontWeight: '600'}}>
                Accounts contacts
            </h3>
            {contacts.length > 0 ? (
                <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                    {contacts.map(contact => (
                        <div key={contact.id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '6px'}}>
                            <div>
                                <p style={{...styles.whiteText, margin: 0, fontWeight: '500'}}>{contact.name}</p>
                                <p style={{...styles.mutedText, margin: 0, fontSize: '14px'}}>{contact.phone}</p>
                            </div>
                            <button onClick={() => onDelete(contact.id)} style={{...styles.button, ...styles.buttonDanger, padding: '6px 12px', fontSize: '13px'}}>
                                🗑️ Delete
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <p style={styles.mutedText}>No additional account contacts found.</p>
            )}
        </div>
    );
};


const CustomerProfile = (props) => {
    const { organizationId, contactId } = props.match.params;
    const dispatch = useDispatch();
    const [userData, setUserData] = useState(null); // Initialize with null
    const { setUnreadNotificationCount } = bindActionCreators(actionCreators, dispatch);

    // Customer Data States
    const [customer, setCustomer] = useState({});
    const [outstandingInvoices, setOutstandingInvoices] = useState([]);
    const [financialSummary, setFinancialSummary] = useState({});
    const [interactionStats, setInteractionStats] = useState({});
    const [interactions, setInteractions] = useState([]); // Initialize as empty array
    const [loading, setLoading] = useState(true);
    const [activeTranscript, setActiveTranscript] = useState(null);

    // Phone Editing State
    const [isEditingPhoneNumber, setIsEditingPhoneNumber] = useState(false);
    const [phoneNumberInput, setPhoneNumberInput] = useState('');

    const [accountContacts, setAccountContacts] = useState([]);
    const [showAddContactForm, setShowAddContactForm] = useState(false);
    const [newContactName, setNewContactName] = useState('');
    const [newContactPhone, setNewContactPhone] = useState('');

    // Audio Player State
    const [playingInteractionId, setPlayingInteractionId] = useState(null);
    const [audioProgress, setAudioProgress] = useState(0);
    const [audioDuration, setAudioDuration] = useState(0);
    const [currentAudio, setCurrentAudio] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);

    // Stats State
    const [stats, setStats] = useState({
        totalCalls: 0,
        totalCollected: 0,
        remainingAmount: 0,
        lastPaymentDate: null,
    });

    // Customer Settings Overrides State
    const [showOverrides, setShowOverrides] = useState(false);
    const [overrides, setOverrides] = useState({
        aiVoice: '',
        aiPersonality: '',
        knownCustomerGreeting: '',
        unknownCustomerGreeting: '',
        initialWaitDays: '',
        followUpFrequency: '',
        maxAttempts: '',
        timetable: null as any,
    });
    const [useCustomSchedule, setUseCustomSchedule] = useState(false);
    const [overridesLoading, setOverridesLoading] = useState(false);
    const [overridesSaving, setOverridesSaving] = useState(false);
    const [overridesLastSaved, setOverridesLastSaved] = useState(null);

    // const reduxState = useSelector((state: State) => state); // Renamed to avoid conflict if 'state' is used elsewhere
    // const [unreadMsgCount, setUnreadMsgCount] = useState(0); // Uncomment if used
    const user = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);

    const fetchCustomerData = useCallback(async () => {
        setLoading(true);
        try {
            const params = {
                method: 'get-customer-data',
                data: { organizationId, contactId },
            };
            const response = await userService.aiRequest(params, true);
            if (response.data) {
                setCustomer(response.data.customerInfo || {});
                setPhoneNumberInput(response.data.customerInfo?.phone || '');
                setOutstandingInvoices(response.data.outstandingInvoices || []);
                setFinancialSummary(response.data.financialSummary || {});
                setInteractionStats(response.data.interactionStats || {});
            } else {
                ValidationErrorToast("Error", "Could not retrieve customer data.");
            }
        } catch (e) {
            console.error("Error fetching customer data:", e);
            ValidationErrorToast("Error", "Failed to fetch customer data.");
        } finally {
            setLoading(false);
        }
    }, [organizationId, contactId]); // Dependencies for useCallback

    const fetchCustomerOverrides = useCallback(async () => {
        if (!organizationId || !contactId) return;
        setOverridesLoading(true);
        try {
            const response = await userService.aiRequest({
                method: 'get-customer-settings-overrides',
                data: { organization_id: organizationId, contact_id: contactId }
            }, true);
            if (response.data?.success && response.data?.overrides) {
                const o = response.data.overrides;
                setOverrides({
                    aiVoice: o.aiVoice || '',
                    aiPersonality: o.aiPersonality || '',
                    knownCustomerGreeting: o.knownCustomerGreeting || '',
                    unknownCustomerGreeting: o.unknownCustomerGreeting || '',
                    initialWaitDays: o.initialWaitDays != null ? String(o.initialWaitDays) : '',
                    followUpFrequency: o.followUpFrequency || '',
                    maxAttempts: o.maxAttempts != null ? String(o.maxAttempts) : '',
                    timetable: o.timetable || null,
                });
                if (o.timetable && Array.isArray(o.timetable)) {
                    setUseCustomSchedule(true);
                }
                if (response.data.updatedAt) setOverridesLastSaved(response.data.updatedAt);
            }
        } catch (error) {
            console.error('Error fetching customer overrides:', error);
        } finally {
            setOverridesLoading(false);
        }
    }, [organizationId, contactId]);

    const handleSaveOverrides = async () => {
        setOverridesSaving(true);
        try {
            const payload = {
                aiVoice: overrides.aiVoice || null,
                aiPersonality: overrides.aiPersonality || null,
                knownCustomerGreeting: overrides.knownCustomerGreeting || null,
                unknownCustomerGreeting: overrides.unknownCustomerGreeting || null,
                initialWaitDays: overrides.initialWaitDays ? Number(overrides.initialWaitDays) : null,
                followUpFrequency: overrides.followUpFrequency || null,
                maxAttempts: overrides.maxAttempts ? Number(overrides.maxAttempts) : null,
                timetable: useCustomSchedule ? overrides.timetable : null,
            };
            const response = await userService.aiRequest({
                method: 'save-customer-settings-overrides',
                data: { organization_id: organizationId, contact_id: contactId, overrides: payload }
            }, true);
            if (response.data?.success) {
                SuccessToast('Success', 'Customer settings overrides saved!');
                setOverridesLastSaved(new Date().toISOString());
            } else {
                ValidationErrorToast('Error', response.data?.error || 'Failed to save overrides.');
            }
        } catch (error) {
            ValidationErrorToast('Error', 'Failed to save customer settings overrides.');
        } finally {
            setOverridesSaving(false);
        }
    };

    const handleClearOverrides = async () => {
        if (!window.confirm('Reset all overrides for this customer to use organisation defaults?')) return;
        setOverridesSaving(true);
        try {
            const payload = {
                aiVoice: null, aiPersonality: null, knownCustomerGreeting: null,
                unknownCustomerGreeting: null, initialWaitDays: null,
                followUpFrequency: null, maxAttempts: null, timetable: null,
            };
            const response = await userService.aiRequest({
                method: 'save-customer-settings-overrides',
                data: { organization_id: organizationId, contact_id: contactId, overrides: payload }
            }, true);
            if (response.data?.success) {
                setOverrides({ aiVoice: '', aiPersonality: '', knownCustomerGreeting: '', unknownCustomerGreeting: '', initialWaitDays: '', followUpFrequency: '', maxAttempts: '', timetable: null });
                setUseCustomSchedule(false);
                SuccessToast('Success', 'Overrides cleared. Organisation defaults will be used.');
                setOverridesLastSaved(null);
            }
        } catch (error) {
            ValidationErrorToast('Error', 'Failed to clear overrides.');
        } finally {
            setOverridesSaving(false);
        }
    };

    const fetchAccountContacts = useCallback(async () => {
        if (!organizationId || !contactId) return;
        try {
            const response = await userService.aiRequest({
                method: 'get-account-contacts',
                data: { organizationId, contactId }
            }, true);

            if (response.data?.success) {
                setAccountContacts(response.data.contacts || []);
            } else {
                console.error("Could not fetch account contacts:", response.data?.message);
                setAccountContacts([]); // Ensure it's an empty array on failure
            }
        } catch (error) {
            console.error("Error fetching account contacts:", error);
            setAccountContacts([]);
        }
    }, [organizationId, contactId]);

    useEffect(() => {
        if (organizationId && contactId) {
            fetchCustomerData();
            fetchAccountContacts();
            fetchCustomerOverrides();
        }
    }, [organizationId, contactId, fetchCustomerData, fetchAccountContacts, fetchCustomerOverrides]);

    useEffect(() => {
        // Recalculate stats when relevant data changes
        const totalCollected = financialSummary?.collectedAmount || 0;
        const amountOwing = financialSummary?.outstandingAmount || 0;
        const totalCalls = interactionStats?.totalCalls || 0; // Assuming interactionStats provides this

        // Find last payment date from interactions if available
        const paymentInteractions = interactions.filter(i => i.type === 'payment').sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        const lastPaymentDate = paymentInteractions.length > 0 ? paymentInteractions[0].timestamp : null;

        setStats({
            totalCalls: totalCalls,
            totalCollected: totalCollected,
            remainingAmount: amountOwing,
            lastPaymentDate: lastPaymentDate,
        });
    }, [financialSummary, interactionStats, interactions]);


    useEffect(() => {
        const fetchInteractionsInternal = async () => { // Renamed to avoid conflict
            if (!organizationId || !contactId) return;
            try {
                const response = await userService.aiRequest({
                    method: 'get-customer-interactions',
                    data: { contactId, organizationId },
                });

                if (response.data?.interactions?.interactions) {
                    setInteractions(response.data.interactions.interactions.map(interaction => ({
                        id: interaction.id,
                        type: interaction.type,
                        direction: interaction.direction,
                        timestamp: interaction.timestamp,
                        duration: interaction.duration || 0, // Ensure duration is a number
                        outcome: interaction.outcome,
                        summary: interaction.summary,
                        recordingUrl: interaction.recordingUrl, // Corrected from recording_url
                        transcript: interaction.transcript,
                        amount: interaction.amount,
                        method: interaction.method,
                        reference: interaction.reference,
                        invoice: interaction.relatedInvoices?.[0]?.invoiceNumber || null,
                        // Customer info within interaction might be redundant if we have global customer
                    })));
                } else {
                    setInteractions([]);
                }
            } catch (error) {
                console.error('Error fetching interactions:', error);
                setInteractions([]); // Set to empty on error
            }
        };
    
        fetchInteractionsInternal();
    }, [contactId, organizationId]);

    const initiateCall = async (orgId, custId, invoiceId = null) => { // Use passed params
        if (!customer.phone || customer.phone.toLowerCase() === 'no phone number available' || customer.phone.trim() === '') {
            ValidationErrorToast("Info", "Please add a phone number for this customer first.");
            setIsEditingPhoneNumber(true); // Prompt to edit
            return;
        }

        const confirmationMessage = invoiceId 
            ? `Are you sure you want to call ${customer.name || 'this customer'} regarding invoice ${outstandingInvoices.find(inv => inv.invoiceId === invoiceId)?.invoiceNumber || invoiceId}?`
            : `Are you sure you want to call ${customer.name || 'this customer'}?`;

        if (!window.confirm(confirmationMessage)) {
            return; // User clicked 'Cancel'
        }

        try {
            const response = await userService.aiRequest({
                method: 'initiate-call',
                data: {
                    organizationId: orgId,
                    contactId: custId,
                    invoiceId,
                }
            }, true);

            if (response.data?.success) {
                SuccessToast("Success", "Call successfully initiated.");
            } else {
                ValidationErrorToast("Error", `Call could not be initiated: ${response.data?.error || 'Unknown error'}`);
            }
        } catch (error) {
            ValidationErrorToast("Error", `Call could not be initiated: ${error.message || 'Unknown error'}`);
        }
    };
    
    const handleUpdatePhoneNumber = async () => {
        if (!phoneNumberInput || !phoneNumberInput.trim()) { // Check if phoneNumberInput is falsy or empty after trim
            ValidationErrorToast("Validation", "Phone number cannot be empty.");
            return;
        }
        try {
            const params = {
                method: 'update-customer-phone', 
                data: {
                    organizationId,
                    contactId,
                    newPhoneNumber: phoneNumberInput.trim(),
                },
            };
            const response = await userService.aiRequest(params, true);

            if (response.data?.success) {
                SuccessToast("Success", "Phone number updated successfully!");
                setCustomer(prevCustomer => ({ ...prevCustomer, phone: phoneNumberInput.trim() }));
                setIsEditingPhoneNumber(false);
            } else {
                ValidationErrorToast("Error", `Failed to update phone number: ${response.data?.message || 'Unknown error'}`);
            }
        } catch (error) {
            console.error("Error updating phone number:", error);
            ValidationErrorToast("Error", `An error occurred: ${error.message || 'Please try again.'}`);
        }
    };

    const handleSaveNewContact = async () => {
        if (!newContactName.trim() || !newContactPhone.trim()) {
            ValidationErrorToast("Validation", "Name and phone number cannot be empty.");
            return;
        }
        try {
            const response = await userService.aiRequest({
                method: 'add-account-contact',
                data: {
                    organizationId,
                    contactId,
                    name: newContactName.trim(),
                    phone: newContactPhone.trim(),
                }
            }, true);

            if (response.data?.success && response.data?.contact) {
                // Add the new contact from the response to our state for instant UI update
                setAccountContacts(prev => [...prev, response.data.contact]);
                SuccessToast("Success", "Account contact added!");

                // Reset and close form
                setShowAddContactForm(false);
                setNewContactName('');
                setNewContactPhone('');
            } else {
                ValidationErrorToast("Error", response.data?.message || "Failed to save contact.");
            }
        } catch (error) {
            ValidationErrorToast("Error", "An error occurred while saving the contact.");
        }
    };

    const handleDeleteContact = async (accountContactId) => {
        if (window.confirm("Are you sure you want to delete this contact?")) {
            try {
                const response = await userService.aiRequest({
                    method: 'delete-account-contact',
                    data: { account_contact_id: accountContactId }
                }, true);

                if (response.data?.success) {
                    // Remove the contact from our local state for instant UI update
                    setAccountContacts(prev => prev.filter(contact => contact.id !== accountContactId));
                    SuccessToast("Success", "Account contact removed.");
                } else {
                    ValidationErrorToast("Error", response.data?.message || "Failed to delete contact.");
                }
            } catch (error) {
                ValidationErrorToast("Error", "An error occurred while deleting the contact.");
            }
        }
    };

    const handleSeek = (e, interactionId) => {
        if (currentAudio && currentAudio.id === interactionId && audioDuration > 0) {
            const container = e.currentTarget;
            const bounds = container.getBoundingClientRect();
            const x = e.clientX - bounds.left;
            const percentage = x / bounds.width;
            const newTime = percentage * audioDuration;
            currentAudio.currentTime = newTime;
            setAudioProgress(newTime); // Update progress immediately for responsiveness
        }
    };

    const handleStopAudio = useCallback(() => {
        if (currentAudio) {
            currentAudio.pause();
            currentAudio.currentTime = 0; // Reset time
            // Clean up event listeners to prevent memory leaks
            currentAudio.removeEventListener('timeupdate', updateAudioProgress);
            currentAudio.removeEventListener('loadedmetadata', setAudioMeta);
            currentAudio.removeEventListener('ended', handleAudioEnd);
            setCurrentAudio(null);
            setIsPlaying(false);
            setAudioProgress(0);
            setAudioDuration(0); // Reset duration
            setPlayingInteractionId(null);
        }
    }, [currentAudio]); // Add dependencies

    // Define these callbacks outside handlePlayRecording to be stable for removeEventListener
    const updateAudioProgress = useCallback(() => {
        if (currentAudio) setAudioProgress(currentAudio.currentTime);
    }, [currentAudio]);

    const setAudioMeta = useCallback(() => {
        if (currentAudio) setAudioDuration(currentAudio.duration);
    }, [currentAudio]);

    const handleAudioEnd = useCallback(() => {
        setIsPlaying(false);
        // Don't reset progress to 0 here, let it stay at the end
        // setPlayingInteractionId(null); // Keep it playing unless explicitly stopped or new one plays
        // Consider if you want to auto-stop or allow replay
        if (currentAudio) {
             currentAudio.currentTime = 0; // Reset for potential replay
             setAudioProgress(0);
        }
    }, [currentAudio]);


    const handlePauseAudio = () => {
        if (currentAudio) {
            if (isPlaying) {
                currentAudio.pause();
            } else {
                currentAudio.play().catch(err => {
                    console.error("Error resuming play:", err);
                    ValidationErrorToast("Error", "Could not resume audio.");
                });
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handlePlayRecording = useCallback(async (recordingUrl, interactionId) => {
        if (currentAudio && currentAudio.id !== interactionId) { // If different audio is playing, stop it
            handleStopAudio();
        } else if (currentAudio && currentAudio.id === interactionId) { // If same audio, toggle play/pause
            handlePauseAudio();
            return;
        }
        
        // If no audio or different audio was stopped, play new one
        try {
            const audio = new Audio(recordingUrl);
            audio.id = interactionId; // Assign interactionId to audio object for tracking
            
            audio.addEventListener('timeupdate', updateAudioProgress);
            audio.addEventListener('loadedmetadata', setAudioMeta);
            audio.addEventListener('ended', handleAudioEnd);
            audio.addEventListener('error', (e) => {
                console.error("Audio error:", e);
                ValidationErrorToast("Error", "Failed to load or play recording.");
                handleStopAudio(); // Clean up on error
            });

            await audio.play();
            setCurrentAudio(audio); // Set after successful play initiation
            setPlayingInteractionId(interactionId);
            setIsPlaying(true);
        } catch (error) {
            console.error("Play error:", error);
            ValidationErrorToast("Error", "Failed to play recording");
            if (currentAudio) handleStopAudio(); // Clean up if play fails
        }
    }, [currentAudio, handleStopAudio, updateAudioProgress, setAudioMeta, handleAudioEnd]); // Dependencies

    const handlePauseCollection = async () => {
        try {
            const params = { method: 'pause-customer', data: {organizationId, contactId} };
            await userService.aiRequest(params, true);
            SuccessToast("Success", "Collection paused for this customer");
            await fetchCustomerData(); 
        } catch (error) {
            console.error("Error pausing collection:", error);
            ValidationErrorToast("Error", "Failed to pause collection");
        }
    };
    
    const handleResumeCollection = async () => {
        try {
            const params = { method: 'resume-customer', data: {organizationId, contactId} };
            await userService.aiRequest(params, true);
            SuccessToast("Success", "Collection resumed for this customer");
            await fetchCustomerData(); 
        } catch (error) {
            console.error("Error resuming collection:", error);
            ValidationErrorToast("Error", "Failed to resume collection");
        }
    };

    const capitalizeFirst = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const formatDuration = (seconds = 0) => { // Default seconds to 0
        if (typeof seconds !== 'number' || isNaN(seconds)) return '0:00';
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60); // Use Math.floor
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const getOutcomeColor = (outcome) => {
        switch (outcome?.toLowerCase() || '') { // Handle null/undefined outcome
            case 'positive': return '#28a745';
            case 'neutral': return '#ffc107';
            case 'negative': return '#dc3545';
            default: return '#6c757d';
        }
    };

    const handleEmailXeroInvoice = async (xeroInvoiceId, mploiOrganizationId) => {
        if (!xeroInvoiceId || !mploiOrganizationId) {
            ValidationErrorToast("Error", "Missing necessary invoice or organization information to email.");
            return;
        }

        if (!window.confirm(`Are you sure you want to email the invoice to the customer via Xero?`)) {
            return; // User clicked 'Cancel'
        }

        try {
            const response = await userService.aiRequest({
                method: 'email-xero-invoice',
                data: {
                    organization_id: mploiOrganizationId, // Your Mploi system's organization ID
                    xero_invoice_id: xeroInvoiceId     // The actual Xero InvoiceID
                }
            }, true); // 'true' likely means use global loading/toast notifications from userService

            if (response.data?.success) {
                SuccessToast("Success", response.data.message || "Invoice successfully queued for sending via Xero.");
            } else {
                ValidationErrorToast("Error", response.data?.message || "Failed to email invoice via Xero. Please check invoice status in Xero.");
            }
        } catch (error) {
            console.error("Error emailing Xero invoice:", error);
            ValidationErrorToast("Error", `An error occurred while trying to email the invoice: ${error.message || 'Unknown error'}`);
        } finally {
            // Hide loading state if you used one
            // e.g., setLoadingEmailButton(null);
        }
    };

    const handleLogout = (e) => {
        e.preventDefault();
        userService.logout()
          .then(() => { // Removed 'res' as it's not used
            api.deleteApi("device-token/", {
                deviceType: "WEB",
                token: `${cookieService.getCookie("fcm")}`,
              })
              .then(() => { // Removed 'res'
                cookieService.removeAllCookies();
                props.history.push(STRING_CONSTANTS.navigationString.login);
              })
              .catch(() => { // Removed 'e', handle generic error
                cookieService.removeAllCookies(); // Ensure cleanup even on inner error
                props.history.push(STRING_CONSTANTS.navigationString.login);
              });
          })
          .catch((err) => {
            checkData(props, "/", err); // Assuming checkData handles potential logout/redirect
          });
    };
    
    // Back button hover style handling
    const [isBackHovered, setIsBackHovered] = useState(false);
    const backButtonStyle = {
        ...styles.backButton,
        backgroundColor: isBackHovered ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
        borderColor: isBackHovered ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.2)',
    };
    const { logoSrc } = useWhitelabel();
  
    return (
        <section className="main-dashboard-wrap" style={styles.container}>
            <Helmet>
                <title>{customer.name || 'Customer Profile'}</title>
            </Helmet>
            <div id="wrapper" style={{ height: "100vh" }}>
                {/* --- Patricia's Sidebar Makeover 💋 --- */}
                <div style={{
                    width: '90px',
                    backgroundColor: '#fff', // Our sophisticated dark background!
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '24px 0'
                }}>
                    {/* Top section with Logo and optional link */}
                    <div>
                        <Link to="/ar" title="Dashboard">
                           {logoSrc && <img src={logoSrc} style={{ width: '80px', display: 'block', margin: '0 auto' }}  alt="logo" />}
                        </Link>

                    </div>

                    {/* Bottom section with Logout */}
                    <div>
                        <div 
                            style={{ 
                                cursor: "pointer", 
                                color: '#000', // A softer white for a subtle look
                                fontSize: '12px',
                                textAlign: 'center'
                            }}
                            onClick={handleLogout}
                            title="Logout"
                        >
                            Logout
                        </div>
                    </div>
                </div>

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content" style={{overflowY: 'auto'}}> {/* Allow content to scroll */}
                        <div className="container-fluid py-3"> {/* Added padding to container-fluid */}
                            <div style={{marginBottom: '24px'}}>
                                <button 
                                    style={backButtonStyle}
                                    onClick={() => props.history.push('/ar')}
                                    onMouseEnter={() => setIsBackHovered(true)}
                                    onMouseLeave={() => setIsBackHovered(false)}
                                >
                                    <span style={{fontSize: '18px', lineHeight: '1'}}>←</span> 
                                    <span>Back to Dashboard</span>
                                </button>
                            </div>

                            <div className='d-flex justify-content-between align-items-start mb-4'> {/* Changed to align-items-start for better layout with multiline phone */}
                                <div>
                                    <h1 style={{...styles.whiteText, marginBottom: '5px', fontSize: '28px'}}>{customer.name || 'Loading Profile...'}</h1>
                                    {!isEditingPhoneNumber ? (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <p style={{...styles.mutedText, margin: 0, fontSize: '15px'}}>
                                                {customer.phone || "No phone number available"}
                                            </p>
                                            <button
                                                onClick={() => {
                                                    setPhoneNumberInput(customer.phone || ''); 
                                                    setIsEditingPhoneNumber(true);
                                                }}
                                                style={{...styles.button, backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '4px 10px', fontSize: '12px'}}
                                                title="Edit phone number"
                                            >
                                                ✏️ Edit
                                            </button>
                                            <button
                                                onClick={() => setShowAddContactForm(true)}
                                                style={{...styles.button, backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '4px 10px', fontSize: '12px'}}
                                                title="Add a new account contact"
                                            >
                                                👤+ Add Contact
                                            </button>
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' }}>
                                            <input
                                                type="tel"
                                                value={phoneNumberInput}
                                                onChange={(e) => setPhoneNumberInput(e.target.value)}
                                                placeholder="Enter phone number"
                                                style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid rgba(255, 255, 255, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#fff', fontSize: '14px', minWidth: '220px'}}
                                            />
                                            <button onClick={handleUpdatePhoneNumber} style={{...styles.button, ...styles.buttonSuccess, padding: '7px 14px', fontSize: '13px'}}>
                                                💾 Save
                                            </button>
                                            <button onClick={() => setIsEditingPhoneNumber(false)} style={{...styles.button, backgroundColor: 'rgba(255,255,255,0.15)', padding: '7px 14px', fontSize: '13px'}}>
                                                ❌ Cancel
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div style={{display: 'flex', gap: '12px', alignItems: 'center', flexShrink: 0}}> {/* Added flexShrink */}
                                    {stats.remainingAmount > 0 && (
                                        <button style={{...styles.button, ...styles.buttonPrimary}} onClick={() => initiateCall(organizationId, contactId)}>
                                            📞 Call Now
                                        </button>
                                    )}
                                    <button 
                                        style={{...styles.button, ...(customer.collectionsDisabled ? styles.buttonSuccess : styles.buttonDanger)}}
                                        onClick={customer.collectionsDisabled ? handleResumeCollection : handlePauseCollection}
                                    >
                                        {customer.collectionsDisabled ? '▶️ Start Collection' : '⏸️ Pause Collection'}
                                    </button>
                                </div>
                            </div>
                            
                            {loading ? (
                                <div style={{textAlign: 'center', padding: '50px', color: '#fff', fontSize: '18px'}}>Loading customer details...</div>
                            ) : (
                                <>
                                    <div className="row">
                                        {[
                                            { label: "Outstanding", value: `$${stats.remainingAmount?.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) || '0.00'}`},
                                            { label: "Collected", value: `$${stats.totalCollected?.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) || '0.00'}`},
                                            { label: "Total Calls", value: `${stats.totalCalls || '0'}`},
                                            { label: "Last Payment", value: stats.lastPaymentDate ? moment(stats.lastPaymentDate).format('DD/MM/YYYY') : 'N/A'},
                                        ].map((stat, index) => (
                                            <div key={index} className="col-xl-3 col-md-6 mb-4">
                                                <div style={styles.blueBox}>
                                                    <div style={styles.statsCard}>
                                                        <div style={styles.statsContent}>
                                                            <h4 style={{...styles.mutedText, fontSize: '14px', marginBottom: '5px'}}>{stat.label}</h4>
                                                            <h2 style={{...styles.whiteText, fontSize: '24px', fontWeight: '600'}}>{stat.value}</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <AccountContactsDisplay contacts={accountContacts} onDelete={handleDeleteContact} />

                                    {/* Customer Settings Overrides Panel */}
                                    <div style={styles.blueBox}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer'}} onClick={() => setShowOverrides(!showOverrides)}>
                                            <h3 style={{...styles.whiteText, margin: 0, fontSize: '20px', fontWeight: '600'}}>
                                                <span style={{marginRight: '10px'}}>⚙️</span>
                                                Customer Settings Overrides
                                            </h3>
                                            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                                {overridesLastSaved && <span style={{...styles.mutedText, fontSize: '12px'}}>Last saved: {moment(overridesLastSaved).format('DD/MM/YYYY HH:mm')}</span>}
                                                <span style={{...styles.whiteText, fontSize: '18px', transition: 'transform 0.2s', transform: showOverrides ? 'rotate(90deg)' : 'rotate(0deg)'}}>▶</span>
                                            </div>
                                        </div>
                                        <p style={{...styles.mutedText, fontSize: '13px', marginTop: '8px', marginBottom: showOverrides ? '20px' : '0'}}>
                                            Override organisation-level settings for this specific customer. Leave blank to use defaults.
                                        </p>
                                        {showOverrides && (
                                            overridesLoading ? (
                                                <div style={{textAlign: 'center', padding: '20px', color: '#555'}}>Loading overrides...</div>
                                            ) : (
                                                <div>
                                                    <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap'}}>
                                                        <div style={{flex: '1 1 300px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '13px', display: 'block', marginBottom: '6px'}}>AI Voice</label>
                                                            <select
                                                                value={overrides.aiVoice}
                                                                onChange={(e) => setOverrides({...overrides, aiVoice: e.target.value})}
                                                                disabled={overridesSaving}
                                                                style={{width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #D1D1D1', backgroundColor: '#fff', color: '#141414', fontSize: '14px'}}
                                                            >
                                                                <option value="">— Use Organisation Default —</option>
                                                                {AVAILABLE_VOICES.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
                                                            </select>
                                                        </div>
                                                        <div style={{flex: '1 1 300px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '13px', display: 'block', marginBottom: '6px'}}>AI Personality</label>
                                                            <select
                                                                value={overrides.aiPersonality}
                                                                onChange={(e) => setOverrides({...overrides, aiPersonality: e.target.value})}
                                                                disabled={overridesSaving}
                                                                style={{width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #D1D1D1', backgroundColor: '#fff', color: '#141414', fontSize: '14px'}}
                                                            >
                                                                <option value="">— Use Organisation Default —</option>
                                                                {PERSONALITY_TYPES.map(p => <option key={p.id} value={p.id}>{p.name} - {p.description}</option>)}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '16px'}}>
                                                        <div style={{flex: '1 1 300px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '13px', display: 'block', marginBottom: '6px'}}>Known Customer Greeting</label>
                                                            <textarea
                                                                value={overrides.knownCustomerGreeting}
                                                                onChange={(e) => setOverrides({...overrides, knownCustomerGreeting: e.target.value})}
                                                                disabled={overridesSaving}
                                                                placeholder="Leave blank to use org default"
                                                                rows={3}
                                                                style={{width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #D1D1D1', backgroundColor: '#fff', color: '#141414', fontSize: '14px', resize: 'vertical'}}
                                                            />
                                                            <p style={{...styles.mutedText, fontSize: '11px', marginTop: '4px'}}>Vars: {'{customer_name}'}, {'{agent_name}'}, {'{organization_name}'}</p>
                                                        </div>
                                                        <div style={{flex: '1 1 300px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '13px', display: 'block', marginBottom: '6px'}}>Unknown Customer Greeting</label>
                                                            <textarea
                                                                value={overrides.unknownCustomerGreeting}
                                                                onChange={(e) => setOverrides({...overrides, unknownCustomerGreeting: e.target.value})}
                                                                disabled={overridesSaving}
                                                                placeholder="Leave blank to use org default"
                                                                rows={3}
                                                                style={{width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #D1D1D1', backgroundColor: '#fff', color: '#141414', fontSize: '14px', resize: 'vertical'}}
                                                            />
                                                            <p style={{...styles.mutedText, fontSize: '11px', marginTop: '4px'}}>Vars: {'{agent_name}'}, {'{organization_name}'}</p>
                                                        </div>
                                                    </div>
                                                    <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '16px'}}>
                                                        <div style={{flex: '1 1 180px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '13px', display: 'block', marginBottom: '6px'}}>Initial Wait Days</label>
                                                            <input
                                                                type="number"
                                                                value={overrides.initialWaitDays}
                                                                onChange={(e) => setOverrides({...overrides, initialWaitDays: e.target.value})}
                                                                disabled={overridesSaving}
                                                                placeholder="Org default"
                                                                min={0}
                                                                style={{width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #D1D1D1', backgroundColor: '#fff', color: '#141414', fontSize: '14px'}}
                                                            />
                                                        </div>
                                                        <div style={{flex: '1 1 180px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '13px', display: 'block', marginBottom: '6px'}}>Follow-up Frequency</label>
                                                            <select
                                                                value={overrides.followUpFrequency}
                                                                onChange={(e) => setOverrides({...overrides, followUpFrequency: e.target.value})}
                                                                disabled={overridesSaving}
                                                                style={{width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #D1D1D1', backgroundColor: '#fff', color: '#141414', fontSize: '14px'}}
                                                            >
                                                                <option value="">— Use Organisation Default —</option>
                                                                {FOLLOW_UP_FREQUENCIES.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
                                                            </select>
                                                        </div>
                                                        <div style={{flex: '1 1 180px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '13px', display: 'block', marginBottom: '6px'}}>Max Attempts</label>
                                                            <input
                                                                type="number"
                                                                value={overrides.maxAttempts}
                                                                onChange={(e) => setOverrides({...overrides, maxAttempts: e.target.value})}
                                                                disabled={overridesSaving}
                                                                placeholder="Org default"
                                                                min={1}
                                                                max={20}
                                                                style={{width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #D1D1D1', backgroundColor: '#fff', color: '#141414', fontSize: '14px'}}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* Custom Schedule Override */}
                                                    <div style={{marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #E0E0E0'}}>
                                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
                                                            <label style={{...styles.mutedText, fontSize: '14px', fontWeight: '600'}}>⏰ Custom Calling Schedule</label>
                                                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                                <span style={{...styles.mutedText, fontSize: '12px'}}>{useCustomSchedule ? 'Custom' : 'Using Org Default'}</span>
                                                                <div 
                                                                    onClick={() => {
                                                                        if (!useCustomSchedule) {
                                                                            const defaultTimetable = DAYS_OF_WEEK.map(day => ({
                                                                                day,
                                                                                shifts: [
                                                                                    { enabled: day !== 'Saturday' && day !== 'Sunday', startTime: '09:00', endTime: '17:00' },
                                                                                    { enabled: false, startTime: '13:00', endTime: '17:00' }
                                                                                ]
                                                                            }));
                                                                            setOverrides({...overrides, timetable: defaultTimetable});
                                                                        }
                                                                        setUseCustomSchedule(!useCustomSchedule);
                                                                    }}
                                                                    style={{width: '44px', height: '24px', borderRadius: '12px', backgroundColor: useCustomSchedule ? '#28a745' : '#D1D1D1', cursor: 'pointer', position: 'relative' as any, transition: 'background-color 0.2s'}}
                                                                >
                                                                    <div style={{width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#fff', position: 'absolute' as any, top: '2px', left: useCustomSchedule ? '22px' : '2px', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)'}} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p style={{...styles.mutedText, fontSize: '12px', marginBottom: useCustomSchedule ? '16px' : '0'}}>Set custom calling hours for this customer. When disabled, the organisation's schedule is used.</p>
                                                        {useCustomSchedule && overrides.timetable && (
                                                            <div>
                                                                {overrides.timetable.map((daySchedule: any, dayIndex: number) => (
                                                                    <div key={daySchedule.day} style={{display: 'flex', alignItems: 'flex-start', padding: '8px 0', borderBottom: '1px solid #E0E0E0', gap: '12px'}}>
                                                                        <div style={{color: '#141414', fontWeight: '600', fontSize: '13px', width: '90px', flexShrink: 0, paddingTop: '6px'}}>{daySchedule.day}</div>
                                                                        <div style={{display: 'flex', flexDirection: 'column' as any, gap: '8px', flexGrow: 1}}>
                                                                            {daySchedule.shifts.map((shift: any, shiftIndex: number) => (
                                                                                <div key={shiftIndex} style={{padding: '8px 12px', background: '#F8F9FA', borderRadius: '6px', border: '1px solid #E0E0E0'}}>
                                                                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: shift.enabled ? '8px' : '0'}}>
                                                                                        <span style={{color: '#777', fontSize: '12px'}}>Shift {shiftIndex + 1}</span>
                                                                                        <div 
                                                                                            onClick={() => {
                                                                                                if (overridesSaving) return;
                                                                                                const newTimetable = [...overrides.timetable];
                                                                                                newTimetable[dayIndex] = {
                                                                                                    ...newTimetable[dayIndex],
                                                                                                    shifts: newTimetable[dayIndex].shifts.map((s: any, si: number) => 
                                                                                                        si === shiftIndex ? {...s, enabled: !s.enabled} : s
                                                                                                    )
                                                                                                };
                                                                                                setOverrides({...overrides, timetable: newTimetable});
                                                                                            }}
                                                                                            style={{width: '36px', height: '20px', borderRadius: '10px', backgroundColor: shift.enabled ? '#28a745' : '#D1D1D1', cursor: overridesSaving ? 'not-allowed' : 'pointer', position: 'relative' as any, transition: 'background-color 0.2s'}}
                                                                                        >
                                                                                            <div style={{width: '16px', height: '16px', borderRadius: '50%', backgroundColor: '#fff', position: 'absolute' as any, top: '2px', left: shift.enabled ? '18px' : '2px', transition: 'left 0.2s', boxShadow: '0 1px 2px rgba(0,0,0,0.15)'}} />
                                                                                        </div>
                                                                                    </div>
                                                                                    {shift.enabled && (
                                                                                        <div style={{display: 'flex', gap: '10px'}}>
                                                                                            <div style={{flex: 1}}>
                                                                                                <label style={{color: '#777', fontSize: '11px', display: 'block', marginBottom: '4px'}}>Start</label>
                                                                                                <input type="time" value={shift.startTime} onChange={e => {
                                                                                                    if (overridesSaving) return;
                                                                                                    const newTimetable = [...overrides.timetable];
                                                                                                    newTimetable[dayIndex] = {
                                                                                                        ...newTimetable[dayIndex],
                                                                                                        shifts: newTimetable[dayIndex].shifts.map((s: any, si: number) => 
                                                                                                            si === shiftIndex ? {...s, startTime: e.target.value} : s
                                                                                                        )
                                                                                                    };
                                                                                                    setOverrides({...overrides, timetable: newTimetable});
                                                                                                }} disabled={overridesSaving} style={{width: '100%', padding: '4px 8px', fontSize: '13px', color: '#141414', backgroundColor: '#fff', border: '1px solid #D1D1D1', borderRadius: '4px'}} />
                                                                                            </div>
                                                                                            <div style={{flex: 1}}>
                                                                                                <label style={{color: '#777', fontSize: '11px', display: 'block', marginBottom: '4px'}}>End</label>
                                                                                                <input type="time" value={shift.endTime} onChange={e => {
                                                                                                    if (overridesSaving) return;
                                                                                                    const newTimetable = [...overrides.timetable];
                                                                                                    newTimetable[dayIndex] = {
                                                                                                        ...newTimetable[dayIndex],
                                                                                                        shifts: newTimetable[dayIndex].shifts.map((s: any, si: number) => 
                                                                                                            si === shiftIndex ? {...s, endTime: e.target.value} : s
                                                                                                        )
                                                                                                    };
                                                                                                    setOverrides({...overrides, timetable: newTimetable});
                                                                                                }} disabled={overridesSaving} style={{width: '100%', padding: '4px 8px', fontSize: '13px', color: '#141414', backgroundColor: '#fff', border: '1px solid #D1D1D1', borderRadius: '4px'}} />
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div style={{display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #E0E0E0'}}>
                                                        <button onClick={handleClearOverrides} disabled={overridesSaving} style={{...styles.button, backgroundColor: '#F0F0F0', color: '#555', padding: '8px 16px', fontSize: '13px'}}>
                                                            🔄 Reset to Defaults
                                                        </button>
                                                        <button onClick={handleSaveOverrides} disabled={overridesSaving} style={{...styles.button, ...styles.buttonSuccess, padding: '8px 20px', fontSize: '13px'}}>
                                                            {overridesSaving ? 'Saving...' : '💾 Save Overrides'}
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>

                                    <div style={styles.blueBox}>
                                        <h3 style={{...styles.whiteText, marginBottom: '20px', fontSize: '20px', fontWeight: '600'}}>
                                            Outstanding Invoices
                                        </h3>
                                        <div className="table-responsive">
                                            <table style={styles.table}>
                                                <thead>
                                                    <tr style={{backgroundColor: 'transparent'}}>
                                                        <th style={styles.tableHeader}>Invoice #</th>
                                                        <th style={styles.tableHeader}>Amount Due</th>
                                                        <th style={styles.tableHeader}>Due Date</th>
                                                        <th style={styles.tableHeader}>Days Overdue</th>
                                                        <th style={{...styles.tableHeader, textAlign: 'center'}}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {outstandingInvoices?.length > 0 ? outstandingInvoices.map((invoice) => (
                                                        <tr key={invoice.id || invoice.invoiceId} style={styles.tableRow}>
                                                            <td style={{...styles.tableCell, borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px'}}>{invoice.invoiceNumber}</td>
                                                            <td style={styles.tableCell}>${invoice.amountDue?.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2})}</td>
                                                            <td style={styles.tableCell}>{moment(invoice.dueDate).format('DD/MM/YYYY')}</td>
                                                            <td style={styles.tableCell}>
                                                                <span style={{
                                                                    ...styles.badge,
                                                                    backgroundColor: invoice.daysOverdue > 90 ? '#dc3545' : invoice.daysOverdue > 30 ? '#ffc107' : invoice.daysOverdue > 0 ? '#17a2b8' : '#28a745',
                                                                    color: invoice.daysOverdue > 30 && invoice.daysOverdue <=90 ? '#212529' : '#ffffff'
                                                                }}>
                                                                    {invoice.daysOverdue > 0 ? `${invoice.daysOverdue} days` : 'Current'}
                                                                </span>
                                                            </td>
                                                            <td style={{...styles.tableCell, textAlign: 'center', borderTopRightRadius: '6px', borderBottomRightRadius: '6px'}}>
                                                                <button style={{...styles.button, ...styles.buttonPrimary, padding: '6px 12px', fontSize: '13px'}} onClick={() => initiateCall(organizationId, contactId, invoice.invoiceId)}>
                                                                    📞 Call
                                                                </button>&nbsp;&nbsp;
                                                                {( // Conditionally show if it's a Xero invoice (assuming you have this info)
                                                                    <button
                                                                        style={{
                                                                            ...styles.button, 
                                                                            backgroundColor: '#17a2b8', // A nice teal/info color
                                                                            padding: '6px 12px', 
                                                                            fontSize: '13px'
                                                                        }}
                                                                        onClick={() => handleEmailXeroInvoice(invoice.invoiceId, organizationId)} // We'll create this function
                                                                        title="Email this invoice to the customer via Xero"
                                                                    >
                                                                        📧 Email
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr><td colSpan="5" style={{...styles.tableCell, textAlign: 'center', padding: '30px'}}>No outstanding invoices.</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    
                                    <div style={styles.blueBox}>
                                        <h3 style={{...styles.whiteText, marginBottom: '20px', fontSize: '20px', fontWeight: '600'}}>
                                            <span style={{marginRight: '10px', verticalAlign: 'middle'}}>📋</span>
                                            Interaction History
                                        </h3>
                                        <div style={styles.timeline}>
                                            {interactions?.length > 0 ? interactions.map((interaction, index) => (
                                                <div key={interaction.id || index} style={{...styles.timelineItem, borderLeft: `2px solid ${index === interactions.length -1 && interactions.length > 1 ? 'transparent' : 'rgba(255, 255, 255, 0.1)'}`}}>
                                                    <div style={{...styles.timelineDot, backgroundColor: interaction.type === 'call' ? getOutcomeColor(interaction.outcome) : '#28a745'}} />
                                                    <div style={{marginBottom: '15px'}}>
                                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px'}}>
                                                            <div>
                                                                <h4 style={{...styles.whiteText, fontSize: '15px', fontWeight: '500'}}>
                                                                    {interaction.type === 'call' ? (<>{interaction.direction === 'outbound' ? '📤 Outbound' : '📥 Inbound'} Call</>) : (<>💵 Payment Received</>)}
                                                                </h4>
                                                                <p style={{...styles.mutedText, fontSize: '13px'}}>{moment(interaction.timestamp).format('DD/MM/YYYY HH:mm')}</p>
                                                            </div>
                                                            {interaction.type === 'call' && interaction.outcome && (
                                                                <span style={{...styles.badge, backgroundColor: getOutcomeColor(interaction.outcome), color: ['#ffc107'].includes(getOutcomeColor(interaction.outcome)) ? '#212529' : '#ffffff'}}>
                                                                    {capitalizeFirst(interaction.outcome)}
                                                                </span>
                                                            )}
                                                        </div>
                                                        {interaction.type === 'call' ? (
                                                            <>
                                                                <p style={{...styles.whiteText, fontSize: '14px'}}>Duration: {formatDuration(interaction.duration)}</p>
                                                                <p style={{...styles.mutedText, fontSize: '14px', lineHeight: '1.5'}}>{interaction.summary || "No summary available."}</p>
                                                                <div style={audioStyles.audioControls}>
                                                                    {interaction.recordingUrl && (playingInteractionId !== interaction.id || !isPlaying) && (
                                                                        <button style={{...audioStyles.controlButton, ...styles.buttonPrimary}} onClick={() => handlePlayRecording(interaction.recordingUrl, interaction.id)}>▶️ Play</button>
                                                                    )}
                                                                    {playingInteractionId === interaction.id && isPlaying && (
                                                                        <button style={{...audioStyles.controlButton, backgroundColor: '#ffc107', color: '#212529'}} onClick={handlePauseAudio}>⏸️ Pause</button>
                                                                    )}
                                                                    {playingInteractionId === interaction.id && (
                                                                        <button style={{...audioStyles.controlButton, backgroundColor: '#dc3545'}} onClick={handleStopAudio}>⏹️ Stop</button>
                                                                    )}
                                                                    {playingInteractionId === interaction.id && audioDuration > 0 && (
                                                                        <>
                                                                            <span style={audioStyles.timeText}>{formatDuration(audioProgress)}</span>
                                                                            <div style={audioStyles.progressContainer} onClick={(e) => handleSeek(e, interaction.id)}>
                                                                                <div style={{...audioStyles.progressBar, width: `${(audioProgress / audioDuration) * 100}%`}}/>
                                                                            </div>
                                                                            <span style={audioStyles.timeText}>{formatDuration(audioDuration)}</span>
                                                                        </>
                                                                    )}
                                                                    {interaction.transcript && (
                                                                        <button style={{...audioStyles.controlButton, backgroundColor: 'rgba(255, 255, 255, 0.1)'}} onClick={() => setActiveTranscript(activeTranscript === interaction.id ? null : interaction.id)}>
                                                                            📄 {activeTranscript === interaction.id ? 'Hide' : 'View'} Transcript
                                                                        </button>
                                                                    )}
                                                                </div>
                                                                {activeTranscript === interaction.id && interaction.transcript && (
                                                                    <div style={styles.transcriptBox}>{interaction.transcript}</div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <p style={{...styles.whiteText, fontSize: '14px'}}>Amount: ${interaction.amount?.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2})}</p>
                                                                <p style={{...styles.mutedText, fontSize: '14px'}}>Invoice: {interaction.invoice || 'N/A'}</p>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )) : (<p style={styles.mutedText}>No interactions recorded for this customer yet.</p>)}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <AddContactModal 
                show={showAddContactForm}
                onClose={() => setShowAddContactForm(false)}
                onSave={handleSaveNewContact}
                name={newContactName}
                setName={setNewContactName}
                phone={newContactPhone}
                setPhone={setNewContactPhone}
            />
        </section>
    );
};

export default withRouter(CustomerProfile);